import React from 'react';

export interface TrendsButtonsProps {
  assignmentType?: 'lesson game' | 'assessment';
  link: string;
}

const TrendsButton = ({ assignmentType = 'assessment', link }: TrendsButtonsProps) => (
  <a
    aria-label={`View ${assignmentType} score trends`}
    className="dropdown-item tw-px-6 !tw-text-neutral-600 focus:tw-bg-inherit"
    href={link}
  >
    <i className="fa fa-bar-chart tw-text-inherit" />
    View
    {' '}
    Trends
  </a>
);

export default TrendsButton;
